import ErrorPage from './ErrorPage.component';

export default ErrorPage;
